<template>
  <footer class="site-footer">
    <div class="container footer-content">
      <div class="footer-story-grid">
        <section class="footer-story">
          <span class="footer-kicker">WHAT WE DO</span>
          <h3>{{ $pick(whatWeDoTitle) }}</h3>
          <p>{{ $pick(whatWeDoText) }}</p>
        </section>

        <section class="footer-story">
          <span class="footer-kicker">ABOUT HONGBANG</span>
          <h3>{{ $pick(aboutTitle) }}</h3>
          <p>{{ $pick(aboutText) }}</p>
        </section>
      </div>

      <section class="footer-advantages">
        <h3>{{ $pick(advantagesTitle) }}</h3>
        <div class="advantage-list">
          <span v-for="item in advantageItems" :key="$pick(item)">{{ $pick(item) }}</span>
        </div>
      </section>

      <div class="footer-main">
        <div class="footer-brand">
          <img alt="HB" src="/logo.png" />
          <div class="footer-brand-copy">
            <h3>{{ $pick(companyName) }}</h3>
            <span>JIANGSU HONGBANG TRANSFORMER CO., LTD.</span>
            <p>{{ $pick(companySummary) }}</p>
          </div>
        </div>

        <nav class="footer-links">
          <h4>{{ quickNavText }}</h4>
          <router-link v-for="item in footerLinks" :key="item.path" :to="item.path">
            {{ $pick(item.label) }}
          </router-link>
        </nav>

        <div class="footer-contact">
          <h4>{{ contactText }}</h4>
          <p>
            <strong>{{ telText }}</strong>
            <span>{{ phone.landline }}</span>
            <div>
              <span>+86 197 3261 2158</span>
            </div>
          </p>
          <p><strong>Email</strong><span>contact@hbtran.com</span></p>
          <p><strong>{{ addressText }}</strong><span>{{ $pick(addressValue) }}</span></p>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div>Copyright © 2026 Jiangsu Hongbang Transformer Co., Ltd.</div>
      <div style="display: flex; justify-content: center">
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=32031202001206" rel="noreferrer" target="_blank" style="display: flex">
          <img src="/beiantubiao.png" style=" width: 16px; margin-right: 10px">
          苏公网安备32031202001206号
        </a>
      </div>
      <div>苏ICP备2026025816号-1</div>
    </div>
  </footer>
</template>

<script>
import { footerLinks, phoneNumbers } from "../../data/site";

export default {
  name: "SiteFooter",
  data() {
    return {
      footerLinks,
      phone: phoneNumbers,
      whatWeDoTitle: {
        "zh-CN": "我们能做什么",
        "en-US": "What We Do"
      },
      whatWeDoText: {
        "zh-CN": "宏邦不仅提供高品质的电力变压器、干式/油浸式变压器、非晶合金变压器、隔离变压器，还配套生产高低压开关柜、箱式变电站（欧变/美变）、输配电箱、电抗器、消弧线圈、矿用及船用特种变压器等全系列输配电设备。同时可承接方案设计、设备集成、安装调试等一站式服务。公司拥有标准化生产基地、全套精密生产检测设备，组建了专业的输配电电气设计团队与工程服务团队，具备完整的输配电系统方案落地能力。依托成熟的技术积累与严苛的品控体系，可为不同行业、不同工况提供定制化、一体化、高适配的输配电整体解决方案。",
        "en-US": "Hongbang supplies high-quality power transformers, dry-type and oil-immersed transformers, amorphous alloy transformers and isolation transformers, together with complete power transmission and distribution equipment including high and low voltage switchgear, prefabricated substations, distribution boxes, reactors, arc suppression coils, and mining or marine special transformers. We also provide one-stop services covering solution design, equipment integration, installation and commissioning. With standardized production bases, precision manufacturing and testing equipment, plus professional power transmission and distribution electrical design and engineering service teams, Hongbang can deliver customized, integrated and highly adaptable power transmission and distribution solutions for different industries and operating conditions."
      },
      aboutTitle: {
        "zh-CN": "关于宏邦",
        "en-US": "About Hongbang"
      },
      aboutText: {
        "zh-CN": "公司生产的S11、S13、S15、S20、S22系列，SCB10、SCB11、SCB13、 SCB14、SCB18和SGB系列，10KV、35KV干式&油浸式变压器、非晶合金、有载调压电力变压器等低损耗电力变压器及各种箱式变电站，技术标准严格采用国际GB1094.1、2-1996；GB/T6451-2008，并在同行中率先获得ISO9001质量体系认证证书，江苏宏邦变压器有限公司的营销及服务网络遍及全国，能保证为客户提供快速、优质服务，公司始终秉承“以人为本，科技创新，志在超越”的崇高信念，以可靠的产品质量，优惠的价格，完善的售后服务，精益求精，追求完美，竭力欢迎新老客户垂询合作，愿与广大客户共创双赢的美好明天。",
        "en-US": "Our company produces S11, S13, S15, S20, and S22 series transformers, SCB10, SCB11, SCB13, SCB14, SCB18, and SGB series transformers, including 10KV and 35KV dry-type and oil-immersed transformers, amorphous alloy transformers, on-load tap-changing power transformers, and various prefabricated substations. Our technical standards strictly adhere to international standards GB1094.1, 2-1996, and GB/T6451-2008. We were among the first in the industry to obtain ISO9001 quality system certification. Jiangsu Hongbang Transformer Co., Ltd. has a nationwide marketing and service network, ensuring fast and high-quality service for our customers. Adhering to the lofty belief of \"people-oriented, technological innovation, and striving for excellence,\" we are committed to providing reliable product quality, competitive prices, and comprehensive after-sales service. We strive for perfection and welcome inquiries and cooperation from new and old customers. We look forward to creating a win-win future together with our customers."
      },
      advantagesTitle: {
        "zh-CN": "我们的优势",
        "en-US": "Our Advantages"
      },
      advantageItems: [
        { "zh-CN": "卓越品质保障", "en-US": "Excellent Quality Assurance" },
        { "zh-CN": "全品类供应支持", "en-US": "Full Category Supply Support" },
        { "zh-CN": "高效贴心服务", "en-US": "Efficient and Attentive Service" }
      ],
      companyName: {
        "zh-CN": "江苏宏邦变压器有限公司",
        "en-US": "Jiangsu Hongbang Transformer Co., Ltd."
      },
      companySummary: {
        "zh-CN": "专注整体输配电系统解决方案，为电力、工业、新能源及工程项目提供可靠设备与服务支持。",
        "en-US": "Focused on integrated power transmission and distribution system solutions, providing reliable equipment and service support for power, industrial, renewable energy and engineering projects."
      },
      addressValue: {
        "zh-CN": "江苏省徐州市铜山区房村镇工业园99号",
        "en-US": "No. 99, Fangcun Town Industrial Park, Tongshan District, Xuzhou City, Jiangsu Province"
      }
    };
  },
  computed: {
    quickNavText() {
      return this.locale === "zh-CN" ? "快捷导航" : "Quick Links";
    },
    contactText() {
      return this.locale === "zh-CN" ? "联系方式" : "Contact";
    },
    telText() {
      return this.locale === "zh-CN" ? "联系电话" : "Tel";
    },
    addressText() {
      return this.locale === "zh-CN" ? "地址" : "Address";
    }
  }
};
</script>

<style scoped>
.site-footer {
  color: rgba(255, 255, 255, 0.86);
  background:
    radial-gradient(circle at 18% 12%, rgba(40, 108, 192, 0.2), transparent 28%),
    linear-gradient(180deg, #102440, #07162a);
}

.footer-content {
  padding: 58px 0 42px;
}

.footer-story-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 26px;
}

.footer-story {
  min-height: 100%;
  padding: 26px 28px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.035);
}

.footer-kicker {
  display: block;
  margin-bottom: 10px;
  color: rgba(118, 177, 255, 0.9);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.16em;
}

.footer-story h3,
.footer-advantages h3,
.footer-brand h3,
.footer-links h4,
.footer-contact h4 {
  margin: 0 0 14px;
  color: #ffffff;
}

.footer-story h3 {
  font-size: 22px;
}

.footer-story p {
  margin: 0;
  color: rgba(236, 243, 255, 0.78);
  font-size: 14px;
  line-height: 1.95;
  text-align: justify;
}

.footer-advantages {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-top: 24px;
  padding: 22px 26px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: linear-gradient(90deg, rgba(26, 111, 203, 0.18), rgba(255, 255, 255, 0.035));
}

.footer-advantages h3 {
  margin-bottom: 0;
  font-size: 20px;
  white-space: nowrap;
}

.advantage-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 12px;
}

.advantage-list span {
  display: inline-flex;
  align-items: center;
  min-height: 36px;
  padding: 0 16px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 999px;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.07);
  font-size: 14px;
  font-weight: 600;
}

.footer-main {
  display: grid;
  grid-template-columns: minmax(0, 1.3fr) minmax(150px, 0.45fr) minmax(280px, 0.8fr);
  gap: 42px;
  margin-top: 44px;
  padding-top: 40px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-brand {
  display: flex;
  align-items: flex-start;
  gap: 18px;
}

.footer-brand img {
  width: 55px;
  height: auto;
  flex: 0 0 auto;
}

.footer-brand-copy {
  padding-top: 8px;
}

.footer-brand-copy p {
  max-width: 560px;
  margin: 0;
  color: rgba(236, 243, 255, 0.76);
  line-height: 1.85;
}

.footer-brand-copy span {
  display: block;
  margin: -6px 0 6px 0;
  color: rgba(255, 255, 255, 0.75);
  font-size: 11px;
  letter-spacing: 0.08em;
  transition: color 0.25s ease;
}

.footer-links {
  display: grid;
  align-content: start;
  gap: 10px;
}

.footer-links a {
  color: rgba(236, 243, 255, 0.78);
  transition: color 0.22s ease, transform 0.22s ease;
}

.footer-links a:hover {
  color: #ffffff;
  transform: translateX(3px);
}

.footer-contact p {
  display: grid;
  gap: 6px;
  margin: 0 0 16px;
  line-height: 1.7;
}

.footer-contact strong {
  color: rgba(118, 177, 255, 0.92);
  font-size: 14px;
}

.footer-contact span {
  color: rgba(236, 243, 255, 0.84);
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  gap: 18px;
  padding: 15px 100px;
  background: rgba(255, 255, 255, 0.045);
  color: rgba(255, 255, 255, 0.9);
  font-size: 13px;
}

@media (max-width: 1100px) {
  .footer-story-grid,
  .footer-main {
    grid-template-columns: 1fr;
  }

  .footer-main {
    gap: 30px;
  }
}

@media (max-width: 900px) {
  .footer-content {
    padding: 42px 0 32px;
  }

  .footer-story {
    padding: 22px 20px;
  }

  .footer-advantages {
    align-items: flex-start;
    flex-direction: column;
    padding: 20px;
  }

  .advantage-list {
    justify-content: flex-start;
  }

  .footer-brand img {
    width: 55px;
  }

  .footer-bottom {
    flex-direction: column;
    padding: 14px 16px;
    text-align: center;
  }
}

@media (max-width: 520px) {
  .footer-story p {
    font-size: 13px;
    line-height: 1.85;
    text-align: left;
  }

  .footer-brand {
    display: grid;
    gap: 12px;
  }

  .advantage-list {
    display: grid;
    grid-template-columns: 1fr;
    width: 100%;
  }

  .advantage-list span {
    justify-content: center;
  }
}
</style>
